import { ajax } from "@/plugins/ajax";

export default {
  namespaced: true,
  state: {
    details: []
  },
  getters: {
    details: (state) => state.details,
  },
  actions: {
    rejectPurchaseOrder({ commit, dispatch }, id) {
      return new Promise((resolve, reject) => {
        ajax
          .put("Procurements/api/PurchaseOrders/go-to-reject", id).then((r) => {
            resolve(r.data);
          })
      });
    },
    acceptPurchaseOrder({ commit, dispatch }, id) {
      return new Promise((resolve, reject) => {
        ajax
          .put("Procurements/api/PurchaseOrders/go-to-confirm" , id)
          .then((r) => {
            // commit("setDetails", r.data);
            resolve(r.data);
          })
      });
    },

    saveCurrencyType({ commit, dispatch }, model) {
      return new Promise((resolve, reject) => {
        ajax
          .put("Procurements/api/PurchaseOrders/set-currency" , model)
          .then((r) => {
            // commit("setDetails", r.data);
            resolve(r.data);
          })
      });
    },
    fetchPurchaseOrder({ commit, dispatch }, id) {
      return new Promise((resolve, reject) => {
        ajax
          .get("Procurements/api/PurchaseOrdersQuery/" + id)
          .then((r) => {
            // commit("setDetails", r.data);
            resolve(r.data);
          })
          .catch((e) => reject(e));
      });
    },
    fetchSearchSupplier({ commit, dispatch }, name) {
        return new Promise((resolve, reject) => {
          ajax
            .get("Procurements/api/SuppliersQuery/" + name)
            .then(r => {
              resolve(r.data);
            })
            .catch(e => {
              reject(e);
            });
        });
      },
    closePurchaseOrder({ commit, dispatch }, id) {
      return new Promise((resolve, reject) => {
        ajax
          .put("Procurements/api/PurchaseOrders/go-to-close", id).then((r) => {
            resolve(r.data);
          })
      });
    },
    saveUnitPrice({ commit, dispatch }, model) {
      return new Promise((resolve, reject) => {
        ajax
          .put("Procurements/api/PurchaseOrders/update-unit-price", model).then((r) => {
            resolve(r.data);
          }).catch((e) => console.log(e));
      });
    },
    saveSupplier({ commit, dispatch }, model) {
      return new Promise((resolve, reject) => {
        ajax
          .put("Procurements/api/PurchaseOrders/set-supplier-info", model).then((r) => {
            resolve(r.data);
          }).catch((e) => console.log(e));
      });
    },
    saveSupplyDate({ commit, dispatch }, model) {
      return new Promise((resolve, reject) => {
        ajax
          .put("Procurements/api/PurchaseOrders/set-supply-clock", model).then((r) => {
            resolve(r.data);
          }).catch((e) => console.log(e));
      });
    },
    saveDeductionAndIncrease({ commit, dispatch }, model) {
      return new Promise((resolve, reject) => {
        ajax
          .put("Procurements/api/PurchaseOrders/update-deduction-and-increases", model).then((r) => {
            resolve(r.data);
          }).catch((e) => console.log(e));
      });
    },

  },
  mutations: {
    setDetails(state, data) {
      state.details = data;
    }
  }
};
